/* ──────────────────────────────────────────────────────────────────────────
 * Oracle {IPO.GPT} knowledge-hub banner — navy variant (self-contained).
 *
 * 1:1 match of the Dashboard-New OracleBanner (`.ob*`) design: navy gradient
 * body, blue glow, "Knowledge Hub" tag pill, cited-sources copy, "Ask →" white
 * button and 4 icon chips. Carries its own concrete-colour CSS so it renders
 * identically in any parent surface. Typing/clicking routes to /oracle?q=…
 * (auto-submits; history persists in oracle_threads / oracle_messages).
 * ────────────────────────────────────────────────────────────────────────── */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OracleKnowledgeBanner.css";

const CHIPS = [
  { icon: "ti-scale", label: "Main Board vs SME?", q: "Main Board vs SME — which IPO route is right for my company?" },
  { icon: "ti-route", label: "The IPO process", q: "Walk me through the full IPO process in India, step by step." },
  { icon: "ti-calculator", label: "How am I valued?", q: "How is my company valued for an IPO in India?" },
  { icon: "ti-clock-dollar", label: "Cost & timeline", q: "What does an IPO cost and how long does it take in India?" },
];

const OracleKnowledgeBanner = ({ className = "" }) => {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const go = (text) => {
    const query = (typeof text === "string" ? text : q).trim();
    if (!query) return;
    navigate(`/oracle?q=${encodeURIComponent(query)}`);
  };
  return (
    <div className={`oknb ${className}`} data-testid="oracle-banner">
      <div className="oknb-glow" aria-hidden="true" />
      <div className="oknb-inner">
        <div className="oknb-top">
          <div className="oknb-logo"><i className="ti ti-sparkles" aria-hidden="true" /></div>
          <div className="oknb-brand">Oracle <span>{"{IPO.GPT}"}</span></div>
          <span className="oknb-tag">Knowledge Hub</span>
        </div>
        <div className="oknb-h">Understand the entire IPO journey — in plain language.</div>
        <div className="oknb-sub">Ask anything about going public in India — eligibility, costs, timelines, DRHP, SEBI rules. Oracle answers with cited, India-specific sources.</div>
        <div className="oknb-bar">
          <i className="ti ti-search oknb-bar-ic" aria-hidden="true" />
          <input
            className="oknb-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") go(); }}
            placeholder="Ask Oracle anything about IPOs in India…"
            data-testid="oracle-banner-input"
          />
          <button className="oknb-ask" onClick={() => go()} data-testid="oracle-banner-ask">Ask →</button>
        </div>
        <div className="oknb-chips">
          {CHIPS.map((c, i) => (
            <button key={i} className="oknb-chip" onClick={() => go(c.q)} data-testid={`oracle-chip-${i}`}>
              <i className={`ti ${c.icon}`} aria-hidden="true" /> {c.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OracleKnowledgeBanner;
